export default __webpack_public_path__ + "static/media/05.7919c118.jpg";